export const Zone = {
  M6: 'M6'
};

export default Zone;
